export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/album_cover_design.2a070aa.svg";